import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getCookie, setCookieWithDefaultDomain, useCustomLocale } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import ConsentNotificationModalComponent from './ConsentNotificationModal.component';
import { MAX_CLOSE_COUNT, ONE_DAY_IN_MINUTES, PUSH_REQUEST_CLOSED_COUNT, PUSH_REQUEST_CLOSED_TIMESTAMP } from './ConsentNotificationModal.constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ConsentNotificationModalContainer(_ref) {
  var _getCookie;
  var handleNotificationPermission = _ref.handleNotificationPermission;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _ref2 = useCustomLocale() || {},
    language = _ref2.language;
  var pushRequestClosedCount = Number((_getCookie = getCookie(PUSH_REQUEST_CLOSED_COUNT)) !== null && _getCookie !== void 0 ? _getCookie : 0);
  var pushRequestClosedTimestamp = getCookie(PUSH_REQUEST_CLOSED_TIMESTAMP);
  var setClosedCountCookie = count => {
    var closedCount = pushRequestClosedCount;
    closedCount = count !== null && count !== void 0 ? count : closedCount + 1;
    setCookieWithDefaultDomain(PUSH_REQUEST_CLOSED_COUNT, closedCount, undefined);
  };
  var setClosedTimestampCookie = () => {
    var currentTimestamp = new Date().toString();
    var cookieExpiresTime = ONE_DAY_IN_MINUTES;
    setCookieWithDefaultDomain(PUSH_REQUEST_CLOSED_TIMESTAMP, currentTimestamp, cookieExpiresTime);
  };
  var handleAllowAction = () => {
    setClosedCountCookie();
    setClosedTimestampCookie();
    handleNotificationPermission(true);
    setIsModalOpen(false);
  };
  var handleDoNotAllowAction = () => {
    setClosedCountCookie(MAX_CLOSE_COUNT);
    setClosedTimestampCookie();
    handleNotificationPermission(false);
    setIsModalOpen(false);
  };
  var handleCloseAction = () => {
    setClosedCountCookie();
    setClosedTimestampCookie();
    handleNotificationPermission(false);
    setIsModalOpen(false);
  };
  useEffect(() => {
    var timer;
    if (pushRequestClosedCount < MAX_CLOSE_COUNT && !pushRequestClosedTimestamp) {
      timer = setTimeout(() => setIsModalOpen(true), 2000);
    }
    return () => clearTimeout(timer);
  }, [pushRequestClosedCount, pushRequestClosedTimestamp]);
  return _jsx(ConsentNotificationModalComponent, {
    isModalVisible: isModalOpen,
    onConsentModalClose: handleCloseAction,
    onConsentModalAllow: handleAllowAction,
    onConsentModalDeny: handleDoNotAllowAction,
    language: language
  });
}